import { Package, Settings, Wand2, Download, LogOut, ChevronLeft } from 'lucide-react';

export const AdminHeader = ({ isArabic, onLogout }) => (
  <header className="bg-black text-white sticky top-0 z-40">
    <div className="container mx-auto px-4 py-4 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <a href="/" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors">
          <ChevronLeft className="w-5 h-5" />
          <span className="text-sm">{isArabic ? 'العودة للموقع' : 'Back to Site'}</span>
        </a>
        <h1 className="text-xl font-bold">{isArabic ? 'لوحة التحكم' : 'Admin Panel'}</h1>
      </div>
      <button
        onClick={onLogout}
        className="flex items-center gap-2 px-4 py-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors text-sm"
        data-testid="logout-btn"
      >
        <LogOut className="w-4 h-4" />
        {isArabic ? 'تسجيل خروج' : 'Logout'}
      </button>
    </div>
  </header>
);

export const AdminTabs = ({ activeTab, setActiveTab, isArabic }) => (
  <div className="bg-white border-b border-slate-200 sticky top-[60px] z-30">
    <div className="container mx-auto px-4">
      <div className="flex gap-1 overflow-x-auto">
        <TabButton
          active={activeTab === 'products'}
          onClick={() => setActiveTab('products')}
          icon={<Package className="w-4 h-4" />}
          label={isArabic ? 'المنتجات' : 'Products'}
          testId="tab-products"
        />
        <TabButton
          active={activeTab === 'settings'}
          onClick={() => setActiveTab('settings')}
          icon={<Settings className="w-4 h-4" />}
          label={isArabic ? 'الإعدادات' : 'Settings'}
          testId="tab-settings"
        />
        <TabButton
          active={activeTab === 'ai-tools'}
          onClick={() => setActiveTab('ai-tools')}
          icon={<Wand2 className="w-4 h-4" />}
          label={isArabic ? 'أدوات الذكاء' : 'AI Tools'}
          testId="tab-ai-tools"
        />
        <TabButton
          active={activeTab === 'backup'}
          onClick={() => setActiveTab('backup')}
          icon={<Download className="w-4 h-4" />}
          label={isArabic ? 'النسخ الاحتياطي' : 'Backup'}
          testId="tab-backup"
        />
      </div>
    </div>
  </div>
);

const TabButton = ({ active, onClick, icon, label, testId }) => (
  <button
    onClick={onClick}
    className={`px-6 py-4 text-sm font-medium transition-colors flex items-center gap-2 whitespace-nowrap ${
      active 
        ? 'text-black border-b-2 border-black' 
        : 'text-slate-500 hover:text-black'
    }`}
    data-testid={testId}
  >
    {icon}
    {label}
  </button>
);

export const Pagination = ({ currentPage, totalPages, onPageChange, isArabic, totalProducts, visibleCount }) => {
  if (totalPages <= 1) return null;
  
  return (
    <>
      <div className="flex items-center justify-center gap-2 mt-8 pb-4" data-testid="pagination">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded-lg flex items-center gap-2 ${
            currentPage === 1
              ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
              : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
          }`}
          data-testid="pagination-prev"
        >
          {isArabic ? 'السابق' : 'Previous'}
        </button>

        <div className="flex items-center gap-1">
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum;
            if (totalPages <= 5) {
              pageNum = i + 1;
            } else if (currentPage <= 3) {
              pageNum = i + 1;
            } else if (currentPage >= totalPages - 2) {
              pageNum = totalPages - 4 + i;
            } else {
              pageNum = currentPage - 2 + i;
            }
            return (
              <button
                key={pageNum}
                onClick={() => onPageChange(pageNum)}
                className={`w-10 h-10 rounded-lg font-medium ${
                  currentPage === pageNum
                    ? 'bg-black text-white'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                }`}
                data-testid={`pagination-page-${pageNum}`}
              >
                {pageNum}
              </button>
            );
          })}
        </div>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 rounded-lg flex items-center gap-2 ${
            currentPage === totalPages
              ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
              : 'bg-slate-200 text-slate-700 hover:bg-slate-300'
          }`}
          data-testid="pagination-next"
        >
          {isArabic ? 'التالي' : 'Next'}
        </button>
      </div>

      <div className="text-center text-sm text-slate-500 mt-2">
        {isArabic 
          ? `عرض ${visibleCount} من ${totalProducts} منتج`
          : `Showing ${visibleCount} of ${totalProducts} products`}
      </div>
    </>
  );
};
